export default __webpack_public_path__ + "7e06644bbdc83069cec8d396149da3ab.woff";